import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import { FormControlLabel, IconButton } from '@mui/material';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Paper from '@mui/material/Paper';
import { t } from 'i18next';
import { List, Map } from 'immutable';
import _ from 'lodash';
import React from 'react';

import { determineIsAccounting, determineIsODLEngineering } from '@sophocles/utils/userPermissionUtils';
import IssueCategoryDialog from '@sophocles/views/admin/management/issueCategories/dialogs/IssueCategoryDialog';
import IssueSubCategoryDialog from '@sophocles/views/admin/management/issueCategories/dialogs/IssueSubCategoryDialog';

class IssueCategoryList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: List(),
      categoryData: List(),
      addCategory: null,
      editCategory: null,
      editIssue: null,
      addIssue: null,
      filter: true,
      search: '',
      errors: null,
      open: false,
      nameError: null,
    };
  }

  // Setup search feature
  updateSearch = event => this.setState({ search: event.target.value });

  // Handle dialog
  closeDialog = () =>
    this.setState({
      editCategory: null,
      editIssue: null,
      addIssue: null,
      addCategory: null,
    });

  clearErrors = () => this.setState({ errors: null });

  openEditDialog = editIssue => this.setState({ editIssue });

  openNewDialog = addIssue => this.setState({ addIssue });

  openNewCategory = () => this.setState({ addCategory: true });

  openEditCategory = editCategory => this.setState({ editCategory });

  openNotes = () => this.setState({ seeNotes: true });

  closeNotes = () => this.setState({ seeNotes: false });

  // Edit a subcategory
  patchIssue = (issue_id, values) => {
    const { patchIssue, setLoading } = this.props;
    setLoading(true);
    patchIssue(issue_id, values).then(res => {
      setLoading(false);
      if (_.has(res, 'error')) {
        if (_.has(res.error.errors, 'non_field_errors')) {
          this.setState({ nameError: res.error.errors.non_field_errors });
          delete res.error.errors.non_field_errors;
        }
        if (Map(res.error.errors).size > 0) {
          alert(
            'Errors: \n\n' +
              Map(res.error.errors)
                .map(x => '- ' + x)
                .join('\n'),
          );
        }
      } else {
        // good to go, re fetch data and close dialog
        this.closeDialog();
        this._fetchData();
      }
    });
  };

  // Create a new subcategory (issue)
  createIssue = (issue_id, values) => {
    const { createIssue, setLoading } = this.props;
    setLoading(true);
    createIssue(values).then(res => {
      setLoading(false);
      if (_.has(res, 'error')) {
        if (_.has(res.error.errors, 'non_field_errors')) {
          this.setState({ nameError: res.error.errors.non_field_errors });
          delete res.error.errors.non_field_errors;
        }
        if (Map(res.error.errors).size > 0) {
          alert(
            'Errors: \n\n' +
              Map(res.error.errors)
                .map(x => '- ' + x)
                .join('\n'),
          );
        }
      } else {
        // good to go, re fetch data and close dialog
        this.closeDialog();
        this._fetchData();
      }
    });
  };

  // Create a new category
  createCategory = (category_id, values) => {
    const { createCategory, setLoading } = this.props;
    setLoading(true);
    createCategory(values).then(res => {
      setLoading(false);
      if (_.has(res, 'error')) {
        if (_.has(res.error.errors, 'name')) {
          this.setState({ nameError: res.error.errors.name });
          delete res.error.errors.name;
        }
        if (Map(res.error.errors).size > 0) {
          alert(
            'Errors: \n\n' +
              Map(res.error.errors)
                .map(x => '- ' + x)
                .join('\n'),
          );
        }
      } else {
        // good to go, re fetch data and close dialog
        this.closeDialog();
        this._fetchData();
      }
    });
  };

  // Edit a category
  patchCategory = (Category_id, values) => {
    const { patchCategory, setLoading } = this.props;
    setLoading(true);
    patchCategory(Category_id, values).then(res => {
      setLoading(false);
      if (_.has(res, 'error')) {
        if (_.has(res.error.errors, 'name')) {
          this.setState({ nameError: res.error.errors.name });
          delete res.error.errors.name;
        }
        if (Map(res.error.errors).size > 0) {
          alert(
            'Errors: \n\n' +
              Map(res.error.errors)
                .map(x => '- ' + x)
                .join('\n'),
          );
        }
      } else {
        // good to go, re fetch data and close dialog
        this.closeDialog();
        this._fetchData();
      }
    });
  };

  // Fetch initial subcategories
  _fetchSubCategories = () => {
    const { fetchSubCategories, setLoading } = this.props;
    setLoading(true);
    fetchSubCategories().then(res => {
      setLoading(false);
      if (_.has(res, 'error')) {
        // fail out
        alert('error while attempting to fetch subcategories');
      } else {
        this.setState({ data: res.get('results') });
      }
    });
  };

  // Fetch initial categories
  _fetchCategories = () => {
    const { fetchCategories, setLoading } = this.props;
    setLoading(true);
    fetchCategories().then(res => {
      setLoading(false);
      if (_.has(res, 'error')) {
        // fail out
        alert('error while attempting to fetch categories');
      } else {
        this.setState({ categoryData: res.get('results') });
      }
    });
  };

  _fetchData = () => {
    this._fetchCategories();
    this._fetchSubCategories();
  };

  componentDidMount() {
    return this._fetchData();
  }

  // Set the filter for the search function
  setFilter = event => {
    event.preventDefault();
    this.setState({ filter: !this.state.filter });
  };

  combineCategoriesAndSubCategories = (categories, subCategories) =>
    categories.map(category =>
      category.set(
        'subCategories',
        subCategories.filter(subCategory => subCategory.getIn(['category', 'id'], 0) == category.get('id', -1)),
      ),
    );

  applyObsoleteFilter = categories =>
    categories
      .filter(category => !category.get('obsolete'))
      .map(category =>
        category.update('subCategories', List(), subCategories =>
          subCategories.filter(subCategory => !subCategory.get('obsolete')),
        ),
      );

  applySearch = categories =>
    categories
      .filter(
        category =>
          category.get('name').toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 ||
          category
            .get('subCategories', List())
            .some(subCategory => subCategory.get('name').toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1),
      )
      .map(category =>
        category.get('name').toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
          ? category
          : category.update('subCategories', List(), subCategories =>
              subCategories.filter(
                subCategory => subCategory.get('name').toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1,
              ),
            ),
      );

  applySort = categories =>
    categories
      .map(category =>
        category.update('subCategories', List(), subCategories =>
          subCategories.sortBy(subCategory => subCategory.get('name').toLowerCase()),
        ),
      )
      .sortBy(category => category.get('name').toLowerCase());

  render() {
    const { user } = this.props;
    const { data, editIssue, categoryData, addCategory, editCategory, search, filter, addIssue, nameError } =
      this.state;

    const isSuperUser = user.get('is_superuser', false);
    const groups = user.get('groups', []);
    const canEdit = isSuperUser || determineIsODLEngineering(groups) || determineIsAccounting(groups);

    // combine categories with subcategories
    const categoriesWithSubCategories = this.combineCategoriesAndSubCategories(categoryData, data);

    // add in the obsolete filter
    const filteredCategoriesWithSubCategories = filter
      ? this.applyObsoleteFilter(categoriesWithSubCategories)
      : categoriesWithSubCategories;

    // now we just need to search
    const searchedCategorieswithSubCategories =
      search !== '' ? this.applySearch(filteredCategoriesWithSubCategories) : filteredCategoriesWithSubCategories;

    // and last, sort the data.
    const sortedCategoriesWithSubCategories = this.applySort(searchedCategorieswithSubCategories);

    return (
      <div style={{ maxWidth: 850, width: '100%', height: '100%', margin: 'auto' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            alignItems: 'flex-end',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '8px' }}>
            <div>
              <Button variant="contained" onClick={this.openNewCategory} color="primary" startIcon={<AddIcon />}>
                {t('general.category', 'Category')}
              </Button>
            </div>
            <div style={{ marginLeft: 8 }}>
              <FormControlLabel
                label={t('admin.showHidden', 'Show Hidden')}
                control={<Checkbox checked={filter} onClick={this.setFilter} />}
              />
            </div>
          </div>
          <div style={{ paddingBottom: '8px' }}>
            Search: <input type="text" value={this.state.search} onChange={this.updateSearch} />
          </div>
        </div>
        <IssueCategories
          categories={sortedCategoriesWithSubCategories}
          openNewDialog={this.openNewDialog}
          openEditCategory={this.openEditCategory}
          openEditDialog={this.openEditDialog}
        />
        {!!editIssue && (
          <IssueSubCategoryDialog
            nameError={nameError}
            open={true}
            closeDialog={this.closeDialog}
            categories={filteredCategoriesWithSubCategories}
            issue={editIssue}
            save={this.patchIssue}
            edit="true"
          />
        )}
        {addIssue && (
          <IssueSubCategoryDialog
            nameError={nameError}
            open={true}
            closeDialog={this.closeDialog}
            categories={filteredCategoriesWithSubCategories}
            save={this.createIssue}
            errors={this.state.errors}
            clearErrors={this.clearErrors}
            issueCategory={addIssue}
          />
        )}
        {addCategory && (
          <IssueCategoryDialog
            nameError={nameError}
            open={true}
            closeDialog={this.closeDialog}
            categories={filteredCategoriesWithSubCategories}
            save={this.createCategory}
            errors={this.state.errors}
            clearErrors={this.clearErrors}
          />
        )}
        {!!editCategory && (
          <IssueCategoryDialog
            nameError={nameError}
            open={true}
            closeDialog={this.closeDialog}
            categories={filteredCategoriesWithSubCategories}
            category={editCategory}
            save={this.patchCategory}
            edit="true"
          />
        )}
      </div>
    );
  }
}
export default IssueCategoryList;

class IssueCategories extends React.Component {
  render() {
    const { openEditDialog, openNewDialog, openEditCategory, filter, categories } = this.props;

    return (
      <div style={{ flex: 1, flexDirection: 'column' }}>
        <div>
          {categories.map((category, i) => (
            <Paper
              key={i}
              sx={{
                width: '100%',
                height: '100%',
                bgcolor: 'background.paper',
                mb: 'var(--space-4)',
              }}
            >
              <div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: 8,
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div
                      style={{
                        color: category.get('obsolete') == true ? 'var(--md-error)' : 'var(--md-primary)',
                        fontSize: 18,
                        paddingLeft: '8px',
                      }}
                    >
                      {category.get('name')}{' '}
                    </div>
                    <div>
                      {category.get('eligible_for_rma') ? (
                        <div style={{ fontSize: 14 }}>&nbsp; - RMA Category</div>
                      ) : null}
                    </div>
                  </div>
                  <div>
                    <Button onClick={() => openEditCategory(category)} color="primary" startIcon={<EditIcon />}>
                      {t('general.category', 'Category')}
                    </Button>
                  </div>
                </div>
                <div>
                  <IssueSubCategories
                    category={category}
                    openNewDialog={openNewDialog}
                    openEditDialog={openEditDialog}
                  />
                </div>
              </div>
            </Paper>
          ))}
        </div>
      </div>
    );
  }
}

class IssueSubCategories extends React.Component {
  render() {
    const { category, openEditDialog, openNewDialog } = this.props;
    return (
      <div>
        {category.get('subCategories').map((subCategory, cellIndex) => (
          <div
            key={cellIndex}
            style={{
              padding: 5,
              backgroundColor: cellIndex % 2 == 0 ? 'var(--grid-row-alt-bg)' : 'var(--surface-primary)',
              display: 'flex',
              flexwWrap: 'wrap',
              justifyContent: 'space-between',
            }}
          >
            <div
              style={{
                paddingTop: 2,
                marginLeft: 20,
                fontSize: 14,
                color: subCategory.get('obsolete') == true ? 'var(--md-error)' : 'var(--text-primary)',
              }}
            >
              {' '}
              {subCategory.get('name')}
            </div>
            <IconButton size="small" onClick={() => openEditDialog(subCategory)}>
              <EditIcon fontSize="small" sx={{ color: 'primary.main' }} />
            </IconButton>
          </div>
        ))}
        {category.get('obsolete') ? null : (
          <div
            style={{
              padding: 5,
              backgroundColor:
                category.get('subCategories').size % 2 == 0 ? 'var(--grid-row-alt-bg)' : 'var(--surface-primary)',
              display: 'flex',
              flexwWrap: 'wrap',
              justifyContent: 'space-between',
            }}
          >
            <div
              onClick={() => openNewDialog(category)}
              style={{
                backgroundColor:
                  category.get('subCategories').size % 2 == 0 ? 'var(--grid-row-alt-bg)' : 'var(--surface-primary)',
                color: 'var(--md-primary)',
                cursor: 'pointer',
                paddingLeft: 20,
                fontSize: 14,
              }}
            >
              <i className="fas fa-plus-square" /> Issue
            </div>
          </div>
        )}
      </div>
    );
  }
}
